import React from "react";
import { Box, Container, Typography, Grid, Stack } from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";

import { Link } from "react-router-dom";

const PHONE_DISPLAY = "+91 81231 98675";
const PHONE_TEL = "+918123198675";

const columns = [
  {
    title: "Ride",
    links: [
      { label: "Find a vehicle", href: "/#fleet" },
      { label: "Pricing", href: "/#fleet" },
      { label: "Ride safety", href: "/#why-choose-us" },
      { label: "How it works", href: "/#how-it-works" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About RideXCity", href: "/#why-choose-us" },
      { label: "Invest with us", href: "/#franchise-invest" },
      { label: "EV Fleet", href: "/#fleet" },
      { label: "FAQ", href: "/#faq" },
    ],
  },
  {
    title: "Support & Legal",
    links: [
      { label: "Help centre", href: "mailto:support@ridexcity.com" },
      { label: "Report an issue", href: `tel:${PHONE_TEL}` },
      { label: "Terms and Conditions", href: "/terms-and-conditions" },
      { label: "Privacy Policy", href: "/privacy-policy" },
    ],
  },
];

export default function Footer() {
  return (
    <Box component="footer" sx={{ bgcolor: "background.paper", py: { xs: 6, md: 8 }, borderTop: "1px solid", borderColor: "divider" }}>
      <Container maxWidth="lg">
        <Grid container spacing={5}>
          <Grid item xs={12} md={3.5}>
            <Box
              component={Link}
              to="/"
              sx={{ display: "inline-block", textDecoration: "none", mb: 2 }}
            >
              <Box
                component="img"
                src="/assets/images/logo.png"
                alt="RideXCity"
                sx={{ height: 42, width: "auto", display: "block" }}
              />
            </Box>
            <Typography sx={{ fontSize: 14, color: "text.secondary", lineHeight: 1.7, maxWidth: 280 }}>
              High-performance electric vehicle rentals for the everyday city commute.
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={2.5}>
            <Typography sx={{ fontWeight: 600, fontSize: 14, color: "text.primary", mb: 2 }}>
              Contact
            </Typography>
            <Stack spacing={1.5}>
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                component="a"
                href={`tel:${PHONE_TEL}`}
                sx={{ textDecoration: "none", color: "text.secondary", "&:hover": { color: "text.primary" } }}
              >
                <CallIcon sx={{ fontSize: 17, color: "primary.dark" }} />
                <Typography sx={{ fontSize: 13.5 }}>{PHONE_DISPLAY}</Typography>
              </Stack>
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                component="a"
                href="mailto:support@ridexcity.com"
                sx={{ textDecoration: "none", color: "text.secondary", "&:hover": { color: "text.primary" } }}
              >
                <EmailIcon sx={{ fontSize: 17, color: "primary.dark" }} />
                <Typography sx={{ fontSize: 13.5 }}>support@ridexcity.com</Typography>
              </Stack>
              <Stack direction="row" spacing={1} alignItems="flex-start">
                <LocationOnIcon sx={{ fontSize: 17, color: "primary.dark", mt: 0.2 }} />
                <Typography sx={{ fontSize: 13.5, color: "text.secondary" }}>
                  2nd Floor, 9, Outer Ring Rd, HBR Layout 5th Block, Banashankari 3rd Stage, Hosakerehalli, Bengaluru, Karnataka 560085
                </Typography>
              </Stack>
            </Stack>
          </Grid>

          {columns.map((col) => (
            <Grid item xs={6} sm={4} md={2} key={col.title}>
              <Typography sx={{ fontWeight: 600, fontSize: 14, color: "text.primary", mb: 2 }}>
                {col.title}
              </Typography>
              <Stack spacing={1.25}>
                {col.links.map((link) => {
                  const isInternal = link.href.startsWith("/") && !link.href.includes("#");
                  return isInternal ? (
                    <Typography
                      key={link.label}
                      component={Link}
                      to={link.href}
                      sx={{ fontSize: 13.5, color: "text.secondary", textDecoration: "none", "&:hover": { color: "primary.main" } }}
                    >
                      {link.label}
                    </Typography>
                  ) : (
                    <Typography
                      key={link.label}
                      component="a"
                      href={link.href}
                      sx={{ fontSize: 13.5, color: "text.secondary", textDecoration: "none", "&:hover": { color: "primary.main" } }}
                    >
                      {link.label}
                    </Typography>
                  );
                })}
              </Stack>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ height: "1px", bgcolor: "divider", my: 5 }} />

        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          spacing={2}
        >
          <Box>
            <Typography sx={{ fontSize: 13, color: "text.secondary", fontWeight: 500 }}>
              © 2026 RideXCity. All Rights Reserved.
            </Typography>
            {/* <Typography sx={{ fontSize: 12, color: "text.secondary", mt: 0.5 }}>
              A product of VALUEAID INFRASTRUCTURE PRIVATE LIMITED.
            </Typography> */}
          </Box>
          <Typography sx={{ fontSize: 13, color: "text.secondary", fontWeight: 500 }}>
            Made in India 🇮🇳
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
